"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Jobs API
 * The Tapis Jobs API executes jobs on Tapis systems.
 *
 * The version of the OpenAPI document: 0.1
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
function ReqSubmitJobFromJSON(json) {
    return ReqSubmitJobFromJSONTyped(json, false);
}
exports.ReqSubmitJobFromJSON = ReqSubmitJobFromJSON;
function ReqSubmitJobFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'owner': !runtime_1.exists(json, 'owner') ? undefined : json['owner'],
        'tenant': !runtime_1.exists(json, 'tenant') ? undefined : json['tenant'],
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'appId': json['appId'],
        'appVersion': json['appVersion'],
        'jobType': !runtime_1.exists(json, 'jobType') ? undefined : json['jobType'],
        'archiveOnAppError': !runtime_1.exists(json, 'archiveOnAppError') ? undefined : json['archiveOnAppError'],
        'dynamicExecSystem': !runtime_1.exists(json, 'dynamicExecSystem') ? undefined : json['dynamicExecSystem'],
        'execSystemId': !runtime_1.exists(json, 'execSystemId') ? undefined : json['execSystemId'],
        'execSystemExecDir': !runtime_1.exists(json, 'execSystemExecDir') ? undefined : json['execSystemExecDir'],
        'execSystemInputDir': !runtime_1.exists(json, 'execSystemInputDir') ? undefined : json['execSystemInputDir'],
        'execSystemOutputDir': !runtime_1.exists(json, 'execSystemOutputDir') ? undefined : json['execSystemOutputDir'],
        'execSystemLogicalQueue': !runtime_1.exists(json, 'execSystemLogicalQueue') ? undefined : json['execSystemLogicalQueue'],
        'archiveSystemId': !runtime_1.exists(json, 'archiveSystemId') ? undefined : json['archiveSystemId'],
        'archiveSystemDir': !runtime_1.exists(json, 'archiveSystemDir') ? undefined : json['archiveSystemDir'],
        'nodeCount': !runtime_1.exists(json, 'nodeCount') ? undefined : json['nodeCount'],
        'coresPerNode': !runtime_1.exists(json, 'coresPerNode') ? undefined : json['coresPerNode'],
        'memoryMB': !runtime_1.exists(json, 'memoryMB') ? undefined : json['memoryMB'],
        'maxMinutes': !runtime_1.exists(json, 'maxMinutes') ? undefined : json['maxMinutes'],
        'fileInputs': !runtime_1.exists(json, 'fileInputs') ? undefined : (json['fileInputs'].map(_1.JobFileInputFromJSON)),
        'fileInputArrays': !runtime_1.exists(json, 'fileInputArrays') ? undefined : (json['fileInputArrays'].map(_1.JobFileInputArrayFromJSON)),
        'parameterSet': !runtime_1.exists(json, 'parameterSet') ? undefined : _1.JobParameterSetFromJSON(json['parameterSet']),
        'execSystemConstraints': !runtime_1.exists(json, 'execSystemConstraints') ? undefined : json['execSystemConstraints'],
        'tags': !runtime_1.exists(json, 'tags') ? undefined : json['tags'],
        'subscriptions': !runtime_1.exists(json, 'subscriptions') ? undefined : (json['subscriptions'].map(_1.NotificationSubscriptionFromJSON)),
        'isMpi': !runtime_1.exists(json, 'isMpi') ? undefined : json['isMpi'],
        'mpiCmd': !runtime_1.exists(json, 'mpiCmd') ? undefined : json['mpiCmd'],
        'cmdPrefix': !runtime_1.exists(json, 'cmdPrefix') ? undefined : json['cmdPrefix'],
    };
}
exports.ReqSubmitJobFromJSONTyped = ReqSubmitJobFromJSONTyped;
function ReqSubmitJobToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'owner': value.owner,
        'tenant': value.tenant,
        'description': value.description,
        'appId': value.appId,
        'appVersion': value.appVersion,
        'jobType': value.jobType,
        'archiveOnAppError': value.archiveOnAppError,
        'dynamicExecSystem': value.dynamicExecSystem,
        'execSystemId': value.execSystemId,
        'execSystemExecDir': value.execSystemExecDir,
        'execSystemInputDir': value.execSystemInputDir,
        'execSystemOutputDir': value.execSystemOutputDir,
        'execSystemLogicalQueue': value.execSystemLogicalQueue,
        'archiveSystemId': value.archiveSystemId,
        'archiveSystemDir': value.archiveSystemDir,
        'nodeCount': value.nodeCount,
        'coresPerNode': value.coresPerNode,
        'memoryMB': value.memoryMB,
        'maxMinutes': value.maxMinutes,
        'fileInputs': value.fileInputs === undefined ? undefined : (value.fileInputs.map(_1.JobFileInputToJSON)),
        'fileInputArrays': value.fileInputArrays === undefined ? undefined : (value.fileInputArrays.map(_1.JobFileInputArrayToJSON)),
        'parameterSet': _1.JobParameterSetToJSON(value.parameterSet),
        'execSystemConstraints': value.execSystemConstraints,
        'tags': value.tags,
        'subscriptions': value.subscriptions === undefined ? undefined : (value.subscriptions.map(_1.NotificationSubscriptionToJSON)),
        'isMpi': value.isMpi,
        'mpiCmd': value.mpiCmd,
        'cmdPrefix': value.cmdPrefix,
    };
}
exports.ReqSubmitJobToJSON = ReqSubmitJobToJSON;
